import React from 'react';
import { Create, required, SelectInput, TextInput } from 'react-admin';
import PersonalityQuizForm from './PersonalityQuizForm';
import { statuses } from '../../../config/constants';

const PersonalityQuizCreate = (props) => (
  <Create title="Create Personality Quiz" {...props}>
    <PersonalityQuizForm redirect="list">
      <TextInput label="Name" source="name" validate={required()} />
      <SelectInput source="status" optionText="name" choices={statuses.slice(0, 2)} validate={required()} />
    </PersonalityQuizForm>
  </Create>
);

export default PersonalityQuizCreate;
